import React from 'react'
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
// import Header from '../../components/Header';
interface NotFoundProps {
    isShowHeader?: boolean;
}

const NotFound: React.FC<NotFoundProps> = ({ isShowHeader = false }) => {
    const navigate = useNavigate();
    return (
        <>
            {/* {isShowHeader && <Header />} */}
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 110px)' }}>
                <div>Not Found page</div>
                <Button type="link" onClick={() => navigate('/reports')} style={{ marginTop: '20px' }}>
                    Go to Reports Page
                </Button>
            </div>
        </>
    )
}

export default NotFound
